import React from 'react';
import {withStyles} from "@material-ui/core/styles";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CommunityStickerPanel from './CommunityStickerPanel';
import Community_Icon from "../assets/community_icon.svg";
import ProjectAlpRun_Logo from "../assets/community/logo.png";
import Background_Matt from "../assets/community/matt.jpg";

const muiTheme = createTheme({
    palette: {
        custom: {
            main: '#FFF'
        },
    },
    components: {
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    backgroundColor: "#000",
                }
            }
        }
    }
});

const useStyles = theme => ({
    panel: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        background: '#B84E31',
    },
    content: {
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        flexDirection: 'column',
        padding: '40px 28px 140px 28px',

        [theme.breakpoints.up('md')]: {
            width: '770px',
            flexDirection: 'row',
            padding: '40px 28px',
        },

        '& a': {
            color: 'inherit',
            textDecoration: 'underline',
        },

        '& a:hover': {
            color: 'inherit',
            textDecoration: 'none',
        }
    },
    icon: {
        padding: '0 0 15px 0',

        [theme.breakpoints.up('md')]: {
            padding: '0 15px 0 0',
        }
    },
    title: {
        fontFamily: 'Young Serif',
        fontSize: '2.6em',
        lineHeight: '1.1em',
    },
    host: {
        padding: '15px 0',
        fontFamily: 'Montserrat',
        fontSize: '1.1em',
        fontWeight: 'bold',
        lineHeight: '1.4em',
        letterSpacing: '0.1em',
        textTransform: 'uppercase',
    },
    description: {
        fontFamily: 'Montserrat',
        fontSize: '1.4em',
        lineHeight: '1.4em',
    },
    links: {
        padding: '20px 0',
        fontFamily: 'Montserrat',
        fontSize: '1.1em',
        fontWeight: 'bold',
        lineHeight: '1.4em',
    },
    logo: {
        padding: '0 0 10px 0',
    },
    media: {
        position: 'relative',
        margin: '20px 0 0 0',

        [theme.breakpoints.up('md')]: {
            margin: '10px 0 0 50px',
        }
    },
    avatar: {
        borderRadius: '25px',
        backgroundImage: 'url(' + Background_Matt + ')',
        backgroundRepeat: 'no-repeat',
        width: '140px',
        height: '205px',
        display: 'flex',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
    },
    stickerContainer: {
        position: 'absolute',
        top: '140px',
        left: '80px',

        '& a, & a:hover': {
            color: 'inherit',
            textDecoration: 'none',
        }
    }
});

class CommunityPanel extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            totalTrees: 0
        };
    }

    render() {
        const { classes } = this.props;

        return (
            <ThemeProvider theme={muiTheme}>

            <div className={classes.panel}>
                <div className={classes.content}>

                    <div className={classes.icon}><img src={Community_Icon} alt={"Community"} /></div>

                    <div className={classes.podcastContent}>
                        <div className={classes.title}>Community Impact</div>
                        <div className={classes.host}>Planting trees against climate change</div>
                        <div className={classes.description}>In 2023 I undertook a challenge many years in the making, to run unsupported across the European Alps - living in the forests for <strong>30 days</strong> and covering a distance of <strong>1,000km</strong>.  Working with <a target="_blank" rel="noopener noreferrer" href="https://trees.org/">Trees for the Future</a>, and with your support, we can reach the goal of planting <strong>20,000</strong> trees.</div>
                        <div className={classes.links}>
                            <div className={classes.logo}><a target="_blank" rel="noopener noreferrer" href="https://www.projectalprun.com/"><img src={ProjectAlpRun_Logo} alt={'Project AlpRun'} /></a></div>
                            <div><a target="_blank" rel="noopener noreferrer" href="https://www.projectalprun.com/">www.projectalprun.com</a></div>
                        </div>
                    </div>

                    <div className={classes.media}>
                        <div><a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/matt-allbeury/"><div className={classes.avatar}></div></a></div>
                        <div className={classes.stickerContainer}><a target="_blank" rel="noopener noreferrer" href="https://www.projectalprun.com/"><CommunityStickerPanel /></a></div>
                    </div>
                </div>
            </div>

            </ThemeProvider>
        )
    }
}

export default withStyles(useStyles)(CommunityPanel)